import { FileText, LayoutGrid, BookOpen, Download } from 'lucide-react';

const HERO_TYPES = [
  { type: 'sell_sheet', label: 'Sell Sheet', Icon: FileText },
  { type: 'planogram', label: 'Planogram', Icon: LayoutGrid },
  { type: 'instructions', label: 'Instructions', Icon: BookOpen },
];

export default function ProductDownloadsCard({ documents }) {
  const docs = Array.isArray(documents) ? documents : [];
  const heroDocs = HERO_TYPES
    .map((h) => {
      const match = docs.find((d) => d && d.url && d.type === h.type);
      return match ? { ...h, doc: match } : null;
    })
    .filter(Boolean);

  if (heroDocs.length === 0) return null;

  return (
    <div
      className="mt-4 border border-zinc-200 rounded-sm bg-white overflow-hidden"
      data-testid="product-downloads-card"
    >
      <div className="bg-zinc-50 px-4 py-2 border-b border-zinc-200">
        <p className="text-[10px] font-bold tracking-widest uppercase text-zinc-400">
          Downloads
        </p>
      </div>
      <div className="divide-y divide-zinc-100">
        {heroDocs.map(({ type, label, Icon, doc }) => (
          <a
            key={type}
            href={doc.url}
            target="_blank"
            rel="noopener noreferrer"
            download={doc.name}
            className="group flex items-center gap-3 px-4 py-3 hover:bg-zinc-50 transition-colors"
            data-testid={`product-download-${type}`}
          >
            <Icon
              size={16}
              strokeWidth={1.5}
              className="text-zinc-400 group-hover:text-red-600 transition-colors flex-shrink-0"
            />
            <span className="flex-1 text-sm text-zinc-700 group-hover:text-zinc-950 transition-colors">
              {label}
            </span>
            <Download
              size={14}
              strokeWidth={1.5}
              className="text-zinc-400 group-hover:text-red-600 transition-colors flex-shrink-0"
            />
          </a>
        ))}
      </div>
    </div>
  );
}
